module.exports = __webpack_public_path__ + "img/react-movies.8be6ff5a.jpg";